import { createFileRoute } from "@tanstack/react-router"

function DemoWarn(props: { for?: string }) {
  const url = new URL(document.location.toString())
  url.pathname = "/demo/" + (props.for || "instacar")
  const urlString = url.toString()

  return (
    <div className="p-12">
      <br />
      Please use the new URL:{" "}
      <a href={urlString} style={{ textDecoration: "underline" }}>
        {urlString}
      </a>
    </div>
  )
}

export const Route = createFileRoute("/demo/")({
  component: () => <DemoWarn for="instacar" />,
})
